import React, { ReactNode } from "react";

import clsx from "clsx";

import Image, { ImageProps } from "next/image";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

import styles from "./index.module.css";

type Props = {
  image: ImageProps["src"];
  imageAlt: string;
  title: string;
  description: ReactNode;
  imageMobile: ImageProps["src"];
};

const ItemContent = ({ image, imageMobile, imageAlt, title, description }: Props) => (
  <>
    <div className="w-4/5 mx-auto py-2 px-4">
      <figure className={clsx(styles.imageContainer, "sm:hidden")}>
        <Image
          src={imageMobile}
          alt={imageAlt}
          layout="responsive"
          quality={100}
          objectFit="contain"
          className="crispImage"
        />
      </figure>
      <figure className={clsx(styles.imageContainer, "hidden sm:block")}>
        <Image
          src={image}
          alt={imageAlt}
          layout="responsive"
          quality={100}
          objectFit="contain"
          className="crispImage"
        />
      </figure>
    </div>

    <HeroSection.Content>
      <HeroSection.Header className="md:items-start text-white">
        <Heading tag="h4">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description className="text-white">{description}</HeroSection.Description>
    </HeroSection.Content>
  </>
);

export default ItemContent;
